

























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Speaker extends Vue {
  @Prop(Object) private speaker: any;

  private avatar: string;
  private customSize: any;

  constructor() {
    super();
    /*
    this.avatar = this.speaker.img
      ? `url(${this.speaker.img})`
      : `url(https://png.pngtree.com/element_our/png/20181206/users-vector-icon-png_260862.jpg)`;
    */

    this.avatar = `url(https://png.pngtree.com/element_our/png/20181206/users-vector-icon-png_260862.jpg)`;``

    this.customSize = this.speaker.customSize
      ? this.speaker.customSize
      : "100%";
  }

  private showProfile(name: string) {
    this.$router.push({ path: "/profile", query: { name } });
  }
}
